import lineClamp from "line-clamp"

// Clamps the hero subtitle to three lines on phone with an inline
// "... show more" that restores the full text. JS truncation (not CSS
// line-clamp) so the link can sit inline after the ellipsis; safe here
// because the subtitle is plain escaped text, unlike the service page's
// markdown description that retired the original version of this script.
export default function ConnectClampedSubtitle() {
  const subtitle = document.querySelector<HTMLElement>("span.connect_subtitle")
  if (!subtitle) return

  const desktop = window.matchMedia("(min-width: 724px)")
  if (desktop.matches) return

  const originalHTML = subtitle.innerHTML

  // Rotating past the breakpoint restores the full text; shrinking back
  // falls to the CSS clamp (without the link) once the class is dropped.
  desktop.addEventListener(
    "change",
    () => {
      subtitle.innerHTML = originalHTML
      subtitle.classList.remove("js-clamped")
    },
    { once: true }
  )

  // Lifts the CSS fallback clamp so the truncation measures real layout.
  subtitle.classList.add("js-clamped")

  const isClamped = lineClamp(subtitle, 3, {ellipsis: "... show more"})
  if (!isClamped) return

  const ellipsisNode = Array.from(subtitle.childNodes).find(node =>
    node.textContent?.includes("... show more")
  )
  if (!ellipsisNode) return

  ellipsisNode.textContent = ellipsisNode.textContent!.replace("show more", "")

  const showMoreLink = document.createElement("a")
  showMoreLink.href = "#"
  showMoreLink.className = "show-more-link"
  showMoreLink.textContent = "show more"

  showMoreLink.addEventListener("click", e => {
    e.preventDefault()
    subtitle.innerHTML = originalHTML
  })

  subtitle.appendChild(showMoreLink)

  // The nowrap link cannot split the way the measured placeholder text could,
  // so trim until it fits back on the third line. Half a line of tolerance:
  // the link's inline box runs a hair taller than the text lines.
  const lineHeight = parseInt(window.getComputedStyle(subtitle).lineHeight, 10)
  const maxHeight = 3 * lineHeight + lineHeight / 2
  let guard = 40
  while (subtitle.scrollHeight > maxHeight && guard-- > 0) {
    const text = ellipsisNode.textContent!
    if (text.length <= 5) break
    ellipsisNode.textContent = `${text.slice(0, -5).trimEnd()}... `
  }
}
